import { Link } from "react-router-dom"
import "./style.css"
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import ScrollAnimationWrapper from "../Other/ScrollAnimationWrapper"
import HomeHeroSection from "./HomeHeroSection"

function Home() {
	return (
		<Container fluid className="p-0" style={{overflow:'hidden'}}>
			<Helmet>
				<title>Home - QuickyChat</title>
				<meta name="description" content="Quickly create AI-powered chatbots that respond with precision and depth. Start building your custom AI agent today!"/>
				<meta name="keywords" content="AI, chatbot, custom chatbot, AI agent, AI-powered chatbot"/>
				<meta name="author" content="QuickyChat"/>
			</Helmet>

			<HomeHeroSection/>

			{/* picture of dashboard */}
			<Container className="dashboard-picture">
				{/* <ScrollAnimationWrapper amount={0.2}> */}
					<Col md={12} className="border border-light rounded">
						<Image className="image" src="/images/dashboard.png" fluid/>
					</Col>
				{/* </ScrollAnimationWrapper> */}
			</Container>

			<Container className="px-4">
				{/* How it works */}
				<Row className="boxed-container py-4">
					<ScrollAnimationWrapper amount={0.2}>
					<h3 className="mb-4">How It Works</h3>
					<hr />
					<Row className="align-items-center">
						{/* Step 1 */}
						<Col md={4} sm={12} className="mb-4 text-center">
							<div className="step-icon mb-3">
								<h1>1</h1>
							</div>
							<h4>Add Knowledgebase</h4>
							<p>Add documents, FAQs, or website URLs to provide your AI agent with essential information.</p>
						</Col>

						{/* Arrow */}
						<Col md={1} className="d-none d-md-flex justify-content-center">
							<span className="arrow">&rarr;</span>
						</Col>

						{/* Step 2 */}
						<Col md={3} className="mb-4 text-center">
							<div className="step-icon mb-3">
								<h1>2</h1>
							</div>
							<h4>Customize AI Agent</h4>
							<p>Define your AI's behavior, responses, and style to suit your needs.</p>
						</Col>

						{/* Arrow */}
						<Col md={1} className="d-none d-md-flex justify-content-center">
							<span className="arrow">&rarr;</span>
						</Col>

						{/* Step 3 */}
						<Col md={3} className="mb-4 text-center">
							<div className="step-icon mb-3">
								<h1>3</h1>
							</div>
							<h4>Deploy Chatbot</h4>
							<p>Embed your AI-powered chatbot on your website or app to start engaging users.</p>
						</Col>
					</Row>
					</ScrollAnimationWrapper>
				</Row>

				<Row className="boxed-container py-4">
					<Col md={6} className="mb-4">
						<ScrollAnimationWrapper>
							<Image 
								src="/images/chatbot-3.png" 
								className="img-fluid rounded align-right" 
							/>
						</ScrollAnimationWrapper>
					</Col>
					<Col md={6}>
						<ScrollAnimationWrapper>
							<h2>Intelligent Chat Experiences</h2>
							<div>
								Our AI-powered chatbot platform helps you create personalized, engaging, and effective chat experiences for
								your users. With our platform, you can:
								<ul>
									<li>Improve customer satisfaction and loyalty</li>
									<li>Reduce support queries and costs</li>
									<li>Enhance user engagement and conversion rates</li>
									<li>Gain valuable insights and analytics</li>
								</ul>
							</div>
						</ScrollAnimationWrapper>
					</Col>
				</Row>
				<Row className="boxed-container py-4">
					<Col md={6} className="order-2 order-md-1">
						<ScrollAnimationWrapper>
							<h2>Realtime Marketing Analytics</h2>
							<p>Track user interactions, sentiment analysis, and more to refine your chatbot's performance</p>
						</ScrollAnimationWrapper>
					</Col>
					<Col md={6} className="order-1 order-md-2 mb-4">
						<ScrollAnimationWrapper>
							<Image src="/images/chart_with_data.png" className="img-fluid rounded"/>
						</ScrollAnimationWrapper>
					</Col>
				</Row>

				{/* Call to Action Section */}
				<Row className="text-center text-white py-5">
					<ScrollAnimationWrapper>
						<Col md={12}>
						<h2 className="py-2">Start Building Your Custom AI Agent Today!</h2>
						<Link to="/dashboard">
							<Button variant="primary" size="lg">
								Start Building for Free
							</Button>
						</Link>
						</Col>
					</ScrollAnimationWrapper>
				</Row>
			</Container>
		</Container>
	)
}

export default Home